import React from 'react';
import { BarGraph } from '@gerdau/hefesto-mais-web';
import {
  Column,
  DataProps
} from '@gerdau/hefesto-mais-web/_shared/graph/graph.types';
import { IDuplicatesByDayData } from '..';
import theme from '../../../../../assets/styles/theme/theme';
import useIsScreenSmallerThan from '../../../../../hooks/useIsScreenSmallerThan';
import { getColorsChartBarsJson } from '../../../../../utils/ColorsChartBars';
import { BarGraphContainer } from '../../../styles';

interface IDuplicatesByDayChart {
  data: IDuplicatesByDayData[];
  isEmpty: boolean;
  allDescriptions: string[];
}

const DuplicatesByDayChart: React.FC<IDuplicatesByDayChart> = ({
  data,
  isEmpty,
  allDescriptions
}) => {
  const chartData: DataProps[] = [];

  const columns: Column[] = [
    {
      colors: {
        tone: '200',
        variant: 'primary'
      },
      dataKey: 'Vencidas',
      dataKeyTitle: 'Vencidas'
    },
    {
      colors: {
        tone: '500',
        variant: 'support-05'
      },
      dataKey: 'A vencer',
      dataKeyTitle: 'A vencer'
    },
    {
      colors: {
        tone: '800',
        variant: 'support'
      },
      dataKey: 'Pagas',
      dataKeyTitle: 'Pagas'
    }
  ];

  data.forEach((item) => {
    let newChartData = {
      date: item.date.slice(0, 2)
    };

    item.duplicates.forEach((duplicate) => {
      newChartData = {
        ...newChartData,
        [duplicate.status]: duplicate.totalInvoice
      };
    });

    chartData.push(newChartData);
  });

  const getColumns = () => {
    const productColorsJson: { [x: string]: Column[] } = {};
    const aux: Column[] = [];
    allDescriptions.forEach((product, idx) => {
      const color = getColorsChartBarsJson(idx);
      const column = {
        dataKey: product,
        dataKeyTitle: product,
        colors: color,

        ...productColorsJson
      };
      aux.push(column);
    });
    return aux;
  };

  const isScreenSmallerThanTablet = useIsScreenSmallerThan(
    Number(theme.breakpoints.tablet.replace('px', ''))
  );

  return (
    <BarGraphContainer>
      <BarGraph
        YAxisWidth={60}
        barDataKey="date"
        legendAlign="left"
        barGap={1}
        barCategoryGap={10}
        columns={isEmpty ? columns : getColumns()}
        dataSource={chartData}
        layout={isScreenSmallerThanTablet ? 'vertical' : 'horizontal'}
        stacked
        showLegend={!isEmpty}
      />
    </BarGraphContainer>
  );
};

export default DuplicatesByDayChart;
